module.exports = "/_next/static/images/projectsBg-ffce02c70740b25d1378cd3cb0c2b4b7.webp";